import React, { useContext, useEffect, useState } from "react";
import { Controller, set, useForm } from "react-hook-form";
import { FormInput } from "../../components/FormInput";
import { useTranslation } from "react-i18next";
import PrimeTableFooter from "../../components/PrimeTableFooter";
import NoInfo from "../../components/NoInfo";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate, useOutletContext } from "react-router-dom";
import { checkDpSuccess, getCompanyType, getMaskedString } from "../../utility/service/tool-service";
import { queryCompaniesList } from "../../utility/service/company-service";
import { classNames } from "primereact/utils";
import { Dropdown } from "primereact/dropdown";
import { SystemLoading, checkLoading } from "../../store/loadingStore";
import { useFuncId } from "../../router/menuRouterMapper";
import { updateAuditEyesEvent } from "../../utility/service/audilog-service";
import { getSubItemsByItemNo } from "../../utility/service/api-service";

const CompanyList_Index = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { itemObj, setItemObj, action, setAction, currentStatus, setCurrentStatus } = useOutletContext();
  const [rows, setRows] = useState([]);
  const [, loading] = useContext(SystemLoading);
  const [companySeq, setCompanySeq] = useState("");
  const [effectiveType, setEffectiveType] = useState([]);
  const [companyLevel, setCompanyLevel] = useState([]);
  const [maskView, setMaskView] = useState(false);
  const chsFuncId = useFuncId();

  const esgClientId = [
    {
      label: t("company.a"),
      value: "A",
    },
    {
      label: t("company.b"),
      value: "B",
    },
    // {
    //     label:t('company.m'),
    //     value:'M'
    // },
  ];

  const {
    register,
    handleSubmit,
    watch,
    clearErrors,
    getValues,
    setValue,
    resetField,
    reset: resetForm,
    control,
    trigger,
    reset,
    formState: { errors, isValid, isDirty },
  } = useForm({
    defaultValues: {
      keywordSearch: "",
      companyType: "A",
    },
    //錯誤驗證時機
    mode: "all",
  });

  const onSubmit = (data) => {
    let reqBody = {
      keywordSearch: data.keywordSearch,
      companyType: data.companyType,
      effectiveType: data.effectiveType,
      companyLevel: data.companyLevel,
    };
    if (data.status !== null && data.status !== "" && data.status !== undefined) {
      reqBody.status = data.status;
    }
    axios_queryCompaniesList(reqBody);
  };

  const checkKeyDown = (e) => {
    if (e.key === "Enter") e.preventDefault();
  };

  //查詢更多
  const btnReadMore = () => {
    axios_queryCompaniesList(
      {
        companyType: getValues("companyType"),
        companySeq: companySeq,
        effectiveType: getValues("effectiveType"),
        companyLevel: getValues("companyLevel"),
      },
      true
    );
  };

  const editItem = (item, act) => {
    setItemObj(item);
    navigate(act);
    setAction(act);
  };

  useEffect(() => {
    let comType = "A";
    if (JSON.stringify(currentStatus) !== "{}") {
      comType = currentStatus?.companyType;
    } else {
      comType = "A";
    }
    setValue("companyType", comType, { shouldValidate: true });
    axios_queryCompaniesList({
      companyType: comType,
      effectiveType: getValues("effectiveType"),
      companyLevel: getValues("companyLevel"),
    });

    getSubItemsByItemNo("EFFECTIVE_TYPE", 17).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.subItems;
        let newArray = data.map((item, index) => {
          return {
            ...item,
            index: index,
          };
        });
        setEffectiveType(newArray);
      }
    });

    getSubItemsByItemNo("COMPANY_LEVEL", 35).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.subItems;
        let newArray = data.map((item, index) => {
          return {
            ...item,
            index: index,
          };
        });
        setCompanyLevel(newArray);
      }
    });
  }, []);

  const axios_queryCompaniesList = (reqBody, readMore = false) => {
    checkLoading(loading);
    setCurrentStatus({
      companyType: reqBody.companyType,
    });
    queryCompaniesList(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          let data = res?.data?.RespBody?.companyList;
          if (data?.length > 0) {
            // let companySeq =
            setCompanySeq(res.data.RespBody.companyList[res.data.RespBody.companyList?.length - 1].companySeq);

            if (readMore === true) {
              setRows((pre) => {
                return [...pre, ...data];
              });
            } else {
              setRows((pre) => {
                return [...data];
              });
            }
          } else {
            if (readMore === false) {
              setRows([]);
            }
          }
        } else {
          if (readMore === false) {
            setRows([]);
          }
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
      });
  };

  const actionBodyTemplate = (rowData, props) => {
    if (rowData) {
      return (
        <>
          <Button
            tooltip={t("button.detail")}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            onClick={() => {
              editItem(rowData, "detail");
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-eye" />
          </Button>
          <Button
            tooltip={t("roleSet")}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            onClick={() => {
              editItem(rowData, "roleMapping");
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-user-pen" />
          </Button>
          <Button
            tooltip={t("acctList")}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            onClick={() => {
              editItem(rowData, "acct");
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-list-check" />
          </Button>
        </>
      );
    }
  };
  const masKAccountTemplate = (rowData, props) => {
    if (rowData) {
      return <>{!maskView ? getMaskedString("account", rowData?.[props?.field]) : rowData?.[props?.field]}</>;
    }
  };

  const effectiveDateTemplate = (rowData, props) => {
    if (rowData) {
      return (
        <span>
          {rowData?.effectiveStartDate} {rowData?.effectiveEndDate ? `~${rowData?.effectiveEndDate}` : ""}
        </span>
      );
    }
  };

  const TransCompanyLevel = (effectiveType) => {
    switch (effectiveType) {
      case "0": //正式
        return (
          <span style={{ color: "var(--primary-color)" }} className="contract-str">
            {t("formal")}
          </span>
        );
      case "1": //試用
        return (
          <span style={{ color: "var(--gray-400)" }} className="contract-str">
            {t("trial")}
          </span>
        );
      default:
        return null;
    }
  };

  const companyLevelNameTemplate = (rowData, props) => {
    if (rowData) {
      switch (rowData?.effectiveType) {
        case "0": //正式
          return (
            <div className="user-avatar-button">
              <span style={{ color: "var(--primary-color)", fontSize: "1rem" }} className="contract-str">
                {t("formal")}
              </span>
            </div>
          );
        case "1": //試用
          return (
            <div className="user-avatar-button">
              <span style={{ color: "var(--gray-400)", fontSize: "1rem" }} className="contract-str">
                {t("trial")}
              </span>
            </div>
          );
        default:
          return null;
      }
    }
  };

  const axios_updateAuditEyesEvent = () => {
    updateAuditEyesEvent({
      functionId: chsFuncId,
      eventType: "V",
    }).then((res) => {
      if (checkDpSuccess(res)) {
      }
    });
  };

  return (
    <>
      <div className="p-card bg-gray">
        <div className="p-card-body">
          <form
            className="flex flex-wrap align-items-center col-12"
            onSubmit={handleSubmit(onSubmit)}
            onKeyDown={checkKeyDown}
          >
            <div className="grid col-12">
              {getCompanyType() === "M" && (
                <>
                  {/*類型*/}
                  <div className="col-2">
                    <label htmlFor="companyType" className="form-label required">
                      {t("type")}
                    </label>
                    <Controller
                      name="companyType"
                      control={control}
                      rules={{ required: { value: true, message: t("validation.required") } }}
                      render={({ field, fieldState }) => (
                        <Dropdown
                          filter
                          optionLabel="label"
                          optionValue="value"
                          value={field.value}
                          virtualScrollerOptions={{ itemSize: 40 }}
                          defaultValue={""}
                          placeholder={t("plz_chs")}
                          name="companyType"
                          control={control}
                          options={esgClientId}
                          className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                          onChange={(event) => {
                            field.onChange(event.value);
                          }}
                        />
                      )}
                    />
                  </div>
                  {/*授權類型*/}
                  <div className="col-2">
                    <label htmlFor="effectiveType" className="form-label">
                      {t("authorizationType")}
                    </label>
                    <Controller
                      name="effectiveType"
                      control={control}
                      render={({ field, fieldState }) => (
                        <Dropdown
                          filter
                          showClear
                          optionLabel="subitemName"
                          optionValue="subitemNo"
                          value={field.value}
                          virtualScrollerOptions={{ itemSize: 40 }}
                          defaultValue={""}
                          placeholder={t("plz_chs_all")}
                          name="effectiveType"
                          control={control}
                          options={effectiveType}
                          className={"w-full"}
                          onChange={(event) => {
                            field.onChange(event.value);
                          }}
                        />
                      )}
                    />
                  </div>
                  {/*會員等級*/}
                  <div className="col-2">
                    <label htmlFor="companyLevel" className="form-label">
                      {t("membershipLevel")}
                    </label>
                    <Controller
                      name="companyLevel"
                      control={control}
                      render={({ field, fieldState }) => (
                        <Dropdown
                          filter
                          showClear
                          optionLabel="subitemName"
                          optionValue="subitemNo"
                          value={field.value}
                          virtualScrollerOptions={{ itemSize: 40 }}
                          defaultValue={""}
                          placeholder={t("plz_chs_all")}
                          name="membershipLevel"
                          control={control}
                          options={companyLevel}
                          className={"w-full"}
                          onChange={(event) => {
                            field.onChange(event.value);
                          }}
                        />
                      )}
                    />
                  </div>
                </>
              )}

              {/*關鍵字*/}
              <div className={`${getCompanyType() === "M" ? "col-6" : "col-12"}`}>
                <FormInput
                  register={register}
                  errors={errors}
                  id="keywordSearch"
                  type="text"
                  placeholder={`${t("company_num")}、${t("organName")}、${t("companyLeader")}`}
                  labelClass="control-label"
                  enterClick={checkKeyDown}
                  labelText={t("keyword")}
                />
              </div>
            </div>
            <div className="col-12 gap-2 flex-all-center">
              <Button disabled={!isValid} type="submit" label={t("button.query")} />
            </div>
          </form>
        </div>
      </div>
      <div className="" style={{ top: "28px" }}>
        <Button
          type="button"
          icon={`pi ${maskView ? "pi-eye" : "pi-eye-slash"}`}
          severity="secondary"
          disabled={rows?.length === 0}
          onClick={() => {
            setMaskView((prev) => {
              if (!prev) {
                axios_updateAuditEyesEvent();
              }
              return !prev;
            });
          }}
        />
      </div>
      <div className="p-card">
        <div className="p-card-body">
          <DataTable
            stripedRows
            className="white-data-table hover-highlight no-shadow"
            tableStyle={{ minWidth: "55rem" }}
            value={rows}
            footer={
              rows.length > 0 && <PrimeTableFooter rowDataList={rows} isShowMore={true} btnReadMore={btnReadMore} />
            }
            emptyMessage={<NoInfo panel="table" />}
          >
            <Column field="taxIdNum" header={t("company_num")} />
            <Column field="name" header={t("organName")} />
            <Column field="leader" header={t("companyLeader")} body={masKAccountTemplate} />
            <Column
              field="effectiveTypeName"
              header={t("authorizationType")}
              body={companyLevelNameTemplate}
              style={{ minWidth: "100px" }}
            />
            <Column
              field="effectiveStartDate"
              header={t("authorizationDate")}
              body={effectiveDateTemplate}
              style={{ minWidth: "120px" }}
            />
            <Column field="companyLevelName" header={t("membershipLevel")} style={{ minWidth: "120px" }} />
            <Column field="industryCodeName" header={t("industry")} style={{ minWidth: "140px" }} />
            <Column
              style={{ minWidth: "170px" }}
              body={actionBodyTemplate}
              header={t("action")}
              frozen
              alignFrozen="right"
            />
          </DataTable>
        </div>
      </div>
    </>
  );
};

export default CompanyList_Index;
